import React from 'react'
import PropTypes from 'prop-types'
import ValidationUI from '../ValidationUI'

const NumberField = (props) => (
    <div>
        {props.wholePositiveNumberStrict 
            ? <input type="number" className="form-control" min='1' {...props} />
            : <input type="number" className="form-control" {...props} />
        }
        { props.touched && (props.error && <ValidationUI error={props.error}/>) }
    </div>

)

NumberField.propTypes = {
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string
}

export default NumberField
